import { Outlet, useLocation } from "react-router-dom";
import { Footer } from "./Footer";
import { Intro } from "./Intro";
import { ScrollMark } from "./ScrollMark";
import { Nav } from "./Nav";
import { SmoothScroll } from "./SmoothScroll";

/** Shell shared by every page: smooth scrolling, the bar, the page, the footer. */
export function Layout() {
  const { pathname } = useLocation();

  return (
    <>
      <SmoothScroll />
      <a
        href="#main"
        className="sr-only z-[60] rounded-full bg-lime px-5 py-3 text-sm font-medium text-ink focus:not-sr-only focus:fixed focus:left-4 focus:top-4"
      >
        Skip to content
      </a>
      <Intro />
      <Nav />
      <ScrollMark />
      {/* Keyed so each page (and the footer under it) replays its reveals. */}
      <main id="main" key={pathname}>
        <Outlet />
      </main>
      <Footer key={`footer:${pathname}`} />
    </>
  );
}
